<template>
	<page>
		<module title="积分规则配置">
            <c-form ref="form">
                <c-form title="积分获取规则">
                    <c-form-item type="radio" label="下单是否赠送积分" name="order_points_enabled" :options="enabledType" required  word="赠送积分将在订单确认收货后到账">></c-form-item>
                    <c-form-item type="number" decimal="2" label="下单时获得1积分需消费" name="order_points_money_unit" :limit="[0.01,9999]" required word="元（获得积分将向下取整,即计算得出应赠送【5.9】分，最终获得积分为【5】分）"></c-form-item>
                    <c-form-item type="number" label="积分有效期时长" name="order_points_expired_period" :limit="[1,9999]" required word="月"></c-form-item>
                </c-form>
                <c-form title="积分抵扣规则">
                    <c-form-item type="number" label="抵扣一元人民币需" name="order_money_points_unit" :limit="[1,9999]" required  word="分（单次抵扣不能少于0.01元）"></c-form-item>
                    <c-form-item type="number" label="单笔订单最高可抵扣" name="order_money_percent" :limit="[0.1,99]"  required word="%（仅考虑商品金额，忽略运费等其他金额）"></c-form-item>
                </c-form>
            </c-form>

            <template slot="button">
                <c-button size="m" @click="submit">提交保存</c-button>
            </template>
		</module>
	</page>
</template>

<script>
	export default {
		name: 'm_points_regulation',
    data() {
      return {
        enabledType: [{
          name: '赠送积分',
          value: 'ON'
        }, {
          name: '不送积分',
          value: 'OFF'
        }]
      }
    },
		mounted() {
            this.request({
                url: '/points_regulation/list',
                success: data => {
                    this.$refs.form.set(data);
                }
            });
		},
		
		methods: {
            submit() {
              this.$refs.form.submit({
                url: '/points_regulation/edit',
                rule: {
                  order_points_enabled: '请选择下单是否赠送积分',
                  order_points_money_unit: '请填写下单时获得1积分需消费金额',
                  order_points_expired_period: '请填写积分有效时长',
                  order_money_points_unit: '请填写积分人民币抵扣比例',
                  order_money_percent: '请填写单笔订单最高可抵扣比例',
                },
                dataFormatter: data => {
                  return data;
                },
                success: () => {
                    this.$message({
                      text: '保存成功'
                    });
                }
              });
            }
		}
	}
</script>